document.addEventListener("latte:init", init);

function init() {
    selectedFilters = [];
    productFilters = [];
    totalVisible = 0;

    checkMatchingProducts();

    $('.js-clear-product-filters').on('click', function(e) {
        e.preventDefault();
        $('.btn-product-filter-active').removeClass('btn-product-filter-active');
        $('.product').show();
        $('.no-products').hide();   
        history.replaceState(null, null, helper.currentURLWithoutQS());
    });

    $('.js-clear-filters-mobile').on('click', function(e) {
        e.preventDefault();
        $('.product-filters a.product-btn, .filters-container a.product-btn').each(function() {
            if($(this).hasClass('btn-product-filter-active')) {
                $(this).removeClass('btn-product-filter-active');
            }
        });
        $('.product').show();
        $('.no-products').hide(); 
        history.replaceState(null, null, helper.currentURLWithoutQS());
    });

    $('.filters-container > a.product-btn').on('click', function(e){
        e.preventDefault();

        var clicked = $(this);

        if ($(this).hasClass('btn-product-filter-active')) {
            $(this).removeClass('btn-product-filter-active');
        } else {
            $(this).addClass('btn-product-filter-active');
            $('.filters-container a.product-btn').not(clicked).removeClass('btn-product-filter-active');
        }

        var dataSort = $(this).attr('data-filter-sort');

        if (dataSort === 'popularity') {
            $(function() {
                $('.product').sort(sort_popular).appendTo('.product-container');
                function sort_popular(a, b) {
                    return ($(b).data('popularity')) < ($(a).data('popularity')) ? 1 : -1;
                }
            });

        } else if (dataSort === 'price-low') {
            $(function() {
                $('.product').sort(sort_price).appendTo('.product-container');
                function sort_price(a, b) {
                    return ($(b).data('price')) < ($(a).data('price')) ? 1 : -1;
                }
            });
        } else if (dataSort === 'price-high') {
            $(function() {
                $('.product').sort(sort_price).appendTo('.product-container');
                function sort_price(a, b) {
                    return ($(b).data('price')) > ($(a).data('price')) ? 1 : -1;
                }
            });
        }
    });

    function checkMatchingProducts() {
        totalVisible = 0;
        $('.product').each(function() {
            if($(this).is(':visible')) {
                totalVisible++;
            }
        });
        if(totalVisible === 0 && $('.product-container').is(':visible')) {
            $('.no-products').show();
        }
    }

    function matchProducts() {
        selectedFilters = [];

        $('.product-filters a').each(function() {
            if($(this).hasClass('btn-product-filter-active')) {
                selectedFilters.push($(this).attr('data-filter').trim());
            }
        });

        selectedFilters.sort();

        function filterProducts(selectedFilters, productFilters){
          for(var i = 0; i < selectedFilters.length; i++){
            if(productFilters.indexOf(selectedFilters[i]) === -1)
               return false;
          }
          return true;
        }

        if(selectedFilters.length > 0) {
            $('.product').each(function() {
                $(this).hide();
                productFilters = $(this).attr('data-filter').split(',');
                productFiltersTrimmed = productFilters.map(function(s) {
                    return s.trim();
                });
                if(filterProducts(selectedFilters, productFiltersTrimmed)) {
                    $(this).show();
                }
            });
        } else {
            $('.product').show();
        }

        checkMatchingProducts();
    }

    // product filter buttons

    $('.product-filters-inner > a.product-btn').on('click', function(e) {
        e.preventDefault();

        $('.no-products').hide();

        if ($(this).hasClass('btn-product-filter-active')) {
            $(this).removeClass('btn-product-filter-active');
        } else {
            $(this).addClass('btn-product-filter-active');
        }

        matchProducts();

        if(selectedFilters.length > 0) {
            newUrl =  helper.currentURLWithoutQS()+'?filters='+selectedFilters.toString();
        } else {
            newUrl =  helper.currentURLWithoutQS();
        }
        history.replaceState(null, null, newUrl);

    });

    //dropdown functions are in standard-dropdown.js look for var sort =

    //default sort by popular
    $(function() {
        $('.product').sort(sort_popular).appendTo('.product-container');
        function sort_popular(a, b) {
            return ($(b).data('popularity')) < ($(a).data('popularity')) ? 1 : -1;
        }
    });

    //mobile filters hide and show

    $('.sort-by-link a').on('click', function(e) {
        e.preventDefault();
        if( $('.filters-container').is(':hidden')) {
            $('.filters-container').show();
            $('.product-filters').removeClass('product-filter-overflow-hidden');
            $('.product-title').hide();
            $('.sort-by-link').hide();
            $('.product-container').hide();
            $('.apply-filters-container').show();
            $('.product-button').css('margin', '20px .375em 0 0; ');
        } else {
            $('.product-title').show();
            $('.filters-container').hide();
            $('.product-filters').addClass('product-filter-overflow-hidden');
            $('.sort-by-link').show();
            $('.product-button').addClass('margin-bottom');
       }
    });

    $('a.close-filters, .apply-filters-container .btn').on('click', function(e) {
        e.preventDefault();
        $('.apply-filters-container').hide();
        $('.sort-by-link').show();
        $('.product-title').show();
        $('.filters-container').hide();
        $('.product-container').show();
        $('.product-filters').addClass('product-filter-overflow-hidden');
        checkMatchingProducts();
    });

    //add hidden on window resize

    (function($) {
        var $window = $(window),
            $html = $('html');

        function resize() {
            if ($window.width() >= 640) {
                $('.product-filters').addClass('product-filter-overflow-hidden');
                $('.product-container').show();
                $('.product-title').show();
            }else if($window.width() < 640){
                if( $('.filters-container').is(':visible')) {
                    $('.product-filters').removeClass('product-filter-overflow-hidden');
                    $('.product-container').hide();
                    $('.product-title').hide();
                }
            }
            // add/remove bos-shadow 
            if ($('.product-filters-inner').width() >= $('.product-filters').width()){
                $('.sort-by-dropdown').addClass('sort-by-dropdown-boxshadow');
            }else{
                $('.sort-by-dropdown').removeClass('sort-by-dropdown-boxshadow');
            }
        }

        $window
            .resize(resize)
            .trigger('resize');
    })(jQuery);



}



//////////////////
// WEBPACK FOOTER
// ./public/js/product-filter.js
// module id = 84
// module chunks = 0